import dayjs from 'dayjs';
import { getRelativeDateLocalization } from '../../../helpers/localization/localizationUtils';

const getDateAriaLabel = (
  departureDate,
  translate,
  departureDateScreenReader,
  localizationData
) => {
  try {
    const localDay = getRelativeDateLocalization(translate, localizationData);
    const dayJSDate = dayjs(departureDate).locale(localDay, null, true);
    const formattedDay = dayJSDate.format(departureDateScreenReader);
    return formattedDay;
  } catch (err) {
    return departureDate;
  }
};

const otherFn = () => {
  return true;
};

export { getDateAriaLabel, otherFn };
